import { Link } from 'react-router-dom';

const QUICK_LINKS = [
  { label: '首页', to: '/' },
  { label: '视频频道', to: '/category/video' },
  { label: '软件频道', to: '/category/software' },
  { label: '教程频道', to: '/category/tutorial' },
];

const INFO_LINKS = [
  { label: '关于我们', to: '/about' },
  { label: '联系反馈', to: '/contact' },
  { label: '免责声明', to: '/about' },
  { label: '版权说明', to: '/about' },
];

const SOCIALS = [
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-qq-line', label: 'QQ' },
  { icon: 'ri-mail-line', label: '邮箱' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100 mt-20">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-400 to-accent-500 text-background-50 font-heading font-bold text-sm flex items-center justify-center">
                91
              </span>
              <span className="font-heading font-semibold text-lg text-background-50">免费91</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              汇聚免费视频、软件与教程，帮助你更高效地获取优质免费资源。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <Link to="/" className="hover:text-accent-300 transition-colors">资源频道</Link>
            </h4>
            <ul className="space-y-3">
              {QUICK_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-background-300 hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">
              <Link to="/about" className="hover:text-accent-300 transition-colors">网站信息</Link>
            </h4>
            <ul className="space-y-3">
              {INFO_LINKS.map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-background-300 hover:text-accent-300 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4">关注我们</h4>
            <div className="flex flex-wrap gap-3 mb-4">
              {SOCIALS.map((item) => (
                <span
                  key={item.label}
                  className="w-9 h-9 rounded-full bg-background-50/10 hover:bg-accent-500 hover:text-background-50 text-background-200 flex items-center justify-center transition-colors cursor-pointer"
                  title={item.label}
                >
                  <i className={`${item.icon} text-base`}></i>
                </span>
              ))}
            </div>
            <p className="text-xs text-background-400 leading-relaxed">
              本站所有资源均为网络收集或作者授权分享，仅供学习交流使用。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-400">© 2026 免费91 · 优质免费资源分享平台</p>
          <p className="text-xs text-background-400">本站为演示项目，内容仅用于展示</p>
        </div>
      </div>
    </footer>
  );
}